import styled from 'styled-components';

import theme from '../../styles/theme';
import logo from '../../../static/image/logo.svg';
import arrow from '../../../static/icons/arrow.svg';
import banner from '../../../static/image/banner.jpg';
import bannerSmall from '../../../static/image/banner_small.png';
import bannerMedium from '../../../static/image/banner_medium.png';

export const Container = styled.header`
  display: flex;
  flex: 2;
  flex-direction: column;
  height: auto;
  padding: 0 18%;
  background: ${theme.faqBrackground} url(${banner}) no-repeat;

  @media (max-width: 1460px) {
    padding: 0 5%;
  }

  @media (max-width: 1024px) {
    background-size: 100% 65%;
    background: ${theme.faqBrackground} url(${bannerMedium}) no-repeat;
  }

  @media (max-width: 600px) {
    background-size: 100% 75%;
    background: ${theme.faqBrackground} url(${bannerSmall}) no-repeat;
  }
`;

export const Content = styled.div`
  display: flex;
  height: 70%;
  flex-direction: row;
  margin-bottom: 40px;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 50px 10px;
  justify-content: flex-start;
  flex: 6;

  &:after {
    content: '';
    width: 25px;
    border-bottom: solid 1px #fff;
    z-index: 1;
    margin-top: 25px;
  }

  @media (max-width: 480px) {
    margin: 10px;

    &:after {
      margin-top: 35px;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  height: 140px;
  justify-content: space-between;
  align-items: center;
`;

export const PartnerLink = styled.a`
  display: ${({ small }) => (small ? 'none' : 'block')};
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;
  color: ${theme.accent};
  text-decoration: none;

  @media (max-width: 900px) {
    display: ${({ small }) => (small ? 'block' : 'none')};
    align-self: flex-end;
    margin-bottom: 30px;
  }
`;

export const Title = styled.h1`
  text-transform: uppercase;
  font-size: 34px;
  margin: 0px;
  font-weight: 100;

  @media (max-width: 480px) {
    font-size: 22px;
  }
`;

export const HighlightTitle = styled(Title)`
  color: ${theme.primary};
  font-weight: bold;
  letter-spacing: 1px;
`;

export const SubTitle = styled.h5`
  text-transform: uppercase;
  margin: 5px;
  font-weight: 600;

  @media (max-width: 480px) {
    margin-bottom: 40px;
  }
`;

export const Text = styled.p`
  font-size: 20px;
  padding-right: 20%;
  color: ${theme.faqBrackground};
  margin: 40px 100px 0 0;

  @media (max-width: 1440px) {
    padding: 0;
  }

  @media (max-width: 480px) {
    margin: 0;
  }
`;

export const Logo = styled.img.attrs({
  src: logo,
})`
  width: 280px;
`;

export const Arrow = styled.img.attrs({
  src: arrow,
})`
  width: 8px;
  height: auto;
  margin-right: 5px;
`;
